import { Helmet } from "react-helmet";
import { SideBar } from "../side-bar/SideBar";
import HrManagementHeader from "./header/HRManagementHeader";
import React, { ChangeEvent, useEffect, useState } from "react";
import { GET_EMPLOYEE_DATA, UPDATE_EMPLOYEE_TIME_SCHEDULE, UPDATE_EMPLOYEE_TIME_SCHEDULE_ONSITE } from "../../../config/config";
import { api, getToken } from "../../../services/apis/auth-api/apiUrl";
import Modal from "../modal/modal";
import EmployeeData from "../modal/hr-management/EmployeeData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faEdit, faSpinner, faTimes } from "@fortawesome/free-solid-svg-icons";
import { convert12HourFormat } from "../../../utils/time.date.utlis";
import { AxiosError } from "axios";

interface EmployeeDataProps {
    user_id : number;
    first_name: string;
    last_name: string;
    email: string;
    position: string;
    department_name: string;
    current_time_sched : string | null;
    current_time_sched_onsite: string | null;
}

interface ExtendedEmpDataProps extends EmployeeDataProps {
    time_sched_editing : boolean;
    time_sched_editing_onsite : boolean;
    flexi : boolean;
    flexi_onsite : boolean; 
    to_update_sign_in : string | null;
    to_update_sign_out : string | null;
    to_update_sign_in_onsite : string | null;
    to_update_sign_out_onsite : string | null;
    btn_loading : boolean;
    btn_loading_onsite : boolean;
}

export default function HrManagementEmployeeData () {
    const [employees, setEmployees] = useState<ExtendedEmpDataProps[] | null>(null);
    const [tbEmployees, setTblEmployees] = useState<ExtendedEmpDataProps[] | null>(null);
    const [employmentStat, setEmploymentStat] = useState<string>('verified');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalChildren, setModalChildren] = useState<React.JSX.Element | null>(null);

    const handleSearchEmp = (e : React.ChangeEvent<HTMLInputElement>) => {
        const value = e.currentTarget.value.toLowerCase();
        if(!employees) return false;
        if(value !== ''){
            const searchRes = employees.filter(emp => 
                emp.last_name.toLowerCase().includes(value) || 
                emp.first_name.toLowerCase().includes(value)
            );
            setTblEmployees(searchRes);
        }else{
            setTblEmployees(employees);
        }
    }

    const createModalContent = (content : React.JSX.Element) =>{
        setModalChildren(content);
        setShowModal(true);
    }

    const convertTime = (timeRange : string) => {
        const [timein, timeout] = timeRange.split("-");
        return `${convert12HourFormat(timein)} - ${convert12HourFormat(timeout)}`;
    }

    const handleTimeEdit = (u_id : number, shift : number) => {
        //shift : 0 = wfh, 1 = onsite
        const editing = tbEmployees?.map(data => data.user_id === u_id ? ({
            ...data,
            time_sched_editing : shift === 0 ? 
                data.time_sched_editing ? false : true
                : data.time_sched_editing,
            time_sched_editing_onsite : shift === 1 ?
                data.time_sched_editing_onsite ? false : true
                : data.time_sched_editing_onsite,
            flexi : !data.current_time_sched ? true : false,
            to_update_sign_in : null,
            to_update_sign_out : null,
            to_update_sign_in_onsite : null,
            to_update_sign_out_onsite : null
        }) : data) as ExtendedEmpDataProps[];
        setTblEmployees(editing);
    }

    const handleTimeDropdown = (u_id: number, shift : number) => {
        //shift : 0 = wfh, 1 = onsite
        const time_dropdown = tbEmployees?.map(data => data.user_id === u_id ? ({
            ...data,
            flexi : shift === 0 ? data.flexi ? false : true : data.flexi,
            flexi_onsite : shift === 1 ? data.flexi_onsite ? false : true : data.flexi_onsite,
            to_update_sign_in : null,
            to_update_sign_out : null,
            to_update_sign_in_onsite : null,
            to_update_sign_out_onsite : null
        }) : data) as ExtendedEmpDataProps[];
        setTblEmployees(time_dropdown);
    }

    const handleEditTimeSched = (e : ChangeEvent<HTMLInputElement>, u_id : number, shift : number) => {
         //shift : 0 = wfh, 1 = onsite
        const input_time_name = e.target.name;
        const input_value = e.target.value;
        let updated_time_sched = [] as ExtendedEmpDataProps[];
        if(input_time_name === 'in'){
            updated_time_sched = tbEmployees?.map(data => u_id === data.user_id ? ({
            ...data,
            to_update_sign_in : shift === 0 ? input_value : data.to_update_sign_in,
            to_update_sign_in_onsite : shift === 1 ? input_value : data.to_update_sign_in_onsite
        }) : data) as ExtendedEmpDataProps[];
        }else{
            updated_time_sched = tbEmployees?.map(data => u_id === data.user_id ? ({
                ...data,
                to_update_sign_out : shift === 0 ? input_value : data.to_update_sign_out,
                to_update_sign_out_onsite : shift === 1 ? input_value : data.to_update_sign_out_onsite
            }) : data) as ExtendedEmpDataProps[];
        }
        setTblEmployees(updated_time_sched);
    }

    const handleUpdateTime = async(u_id : number, shift : number) => {
        try{
            if(tbEmployees === null) return false;
            let emp_data = {} as ExtendedEmpDataProps;
            for(const data of tbEmployees){
                if(data.user_id === u_id) emp_data = data;
            }
            setTblEmployees(tbEmployees.map(data => data.user_id === u_id ? ({
                ...data,
                btn_loading : shift === 0 ? true : data.btn_loading,
                btn_loading_onsite : shift === 1 ? true : data.btn_loading_onsite
            }) : data));

            const time_sched_end_point = shift === 0 ? UPDATE_EMPLOYEE_TIME_SCHEDULE : UPDATE_EMPLOYEE_TIME_SCHEDULE_ONSITE;

            await api.post(time_sched_end_point+u_id, {
                time_in : shift === 0 ? emp_data.to_update_sign_in : emp_data.to_update_sign_in_onsite,
                time_out : shift === 0 ? emp_data.to_update_sign_out : emp_data.to_update_sign_out_onsite
            }, {
                headers: { 'Authorization': 'Bearer ' + getToken() }
            });

            setTblEmployees(tbEmployees.map(data => data.user_id === u_id ? ({
                ...data,
                btn_loading : shift === 0 ? false : data.btn_loading,
                btn_loading_onsite : shift === 1 ? false : data.btn_loading_onsite,
                time_sched_editing : shift === 0 ? false : data.time_sched_editing,
                time_sched_editing_onsite : shift === 1 ? false : data.time_sched_editing_onsite,
                to_update_sign_in : shift === 0 ? null : data.to_update_sign_in,
                to_update_sign_in_onsite : shift === 1 ? null : data.to_update_sign_in_onsite,
                to_update_sign_out : shift === 0 ? null : data.to_update_sign_out,
                to_update_sign_out_onsite : shift === 1 ? null : data.to_update_sign_out_onsite,
                current_time_sched : shift === 0 ? emp_data.to_update_sign_in !== null && emp_data.to_update_sign_out !== null ?
                 `${emp_data.to_update_sign_in} - ${emp_data.to_update_sign_out}` 
                 : null : data.current_time_sched,
                current_time_sched_onsite : shift === 1 ? emp_data.to_update_sign_in_onsite !== null && emp_data.to_update_sign_out_onsite !== null ?
                 `${emp_data.to_update_sign_in_onsite} - ${emp_data.to_update_sign_out_onsite}`
                 : null : data.current_time_sched_onsite
            }) : data));
        }catch(e){
            const error = (e as AxiosError);
            if(error.response?.status === 408){
                alert(error.response.data);
            }else if(error.response?.status === 406){
                alert(error.response.data)
            }else{
                alert('Something went wrong!');
            }
            if(tbEmployees){
                setTblEmployees(tbEmployees.map(data => data.user_id === u_id ? ({
                    ...data,
                    btn_loading : false
                }) : data))
            }
        }
    }

    useEffect(()=>{
        const getEmployee = async()=>{
            try{
                const data = await api.get(GET_EMPLOYEE_DATA+employmentStat, {
                    headers: { 'Authorization': 'Bearer ' + getToken() }
                });
                const emp_data = data.data as EmployeeDataProps[];
                const extended_emp_data = emp_data.map(data => ({
                    ...data, time_sched_editing : false,
                    time_sched_editing_onsite : false,
                    flexi : !data.current_time_sched ? true : false,
                    flexi_onsite : !data.current_time_sched_onsite ? true : false,
                    to_update_sign_in : null,
                    to_update_sign_out : null
                })) as ExtendedEmpDataProps[];
                setEmployees(extended_emp_data);
                setTblEmployees(extended_emp_data);
            }catch(e){}
        }
        getEmployee();
    },[employmentStat]);

    return (
        <div className='content flex'>
            <Helmet>
                <title>Employee Data</title>
            </Helmet>
            <SideBar />
            <div className='main-content py-4'>
                <HrManagementHeader />
                <div className="my-2 bg-gray-100">
                    <div className="p-2">
                        <h1>Employee Data</h1>
                    </div>
                    <div className="flex my-4 px-4">
                        <div>
                            <input type="text" onChange={(e)=>handleSearchEmp(e)} placeholder="Search employee..." className='text-box' />
                        </div>
                        <div className="ms-auto">
                            <select className="text-box" onChange={(e)=>setEmploymentStat(e.currentTarget.value)}>
                                <option value="verified">Active</option>
                                <option value="removed">Resigned</option>
                            </select>
                        </div>
                    </div>
                    <div className="table-container h-full">
                        <table className="w-full h-full border">
                            <thead className="table-fixed-header border">
                                <tr className="bg-gray-100">
                                    <th className='table-headers font-medium'>#</th>
                                    <th className='table-headers font-medium'>Lastname</th>
                                    <th className='table-headers font-medium'>Firstname</th>
                                    <th className='table-headers font-medium'>Middlename</th>
                                    <th className='table-headers font-medium'>Email</th>
                                    <th className='table-headers font-medium'>Time Sched WFH</th>
                                    <th className='table-headers font-medium'>Time Sched Onsite</th>
                                    <th className='table-headers font-medium'>Status</th>
                                    <th className='table-headers font-medium'>Action</th>
                                </tr>
                            </thead>
                            <tbody className="text-center">
                                {tbEmployees ? tbEmployees.map((emp, index)=>(
                                    <tr className="hover:bg-orange-100">
                                        <td className='table-body px-2'>{index + 1}</td>
                                        <td className='table-body px-2'>{emp.last_name}</td>
                                        <td className='table-body px-0'>{emp.first_name}</td>
                                        <td className='table-body px-0'></td>
                                        <td className='table-body px-0'>{emp.email}</td>
                                        <td className='table-body px-0'>
                                            {!emp.time_sched_editing ? (
                                                <div className="flex w-full justify-center items-center gap-4">
                                                    <div>
                                                        {emp.current_time_sched === null || emp.current_time_sched === '' || emp.current_time_sched === undefined ? 'Flexible' : convertTime(emp.current_time_sched)}
                                                    </div>
                                                    <div>
                                                        <button type="button" onClick={()=>handleTimeEdit(emp.user_id, 0)} className="text-blue-500">
                                                            <FontAwesomeIcon icon={faEdit} />
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="flex flex-col gap-2">
                                                    <div>
                                                        <select onChange={()=>handleTimeDropdown(emp.user_id, 0)}>
                                                            <option selected={emp.flexi} value="">Flexible</option>
                                                            <option selected={!emp.flexi} value="1">Set Time</option>
                                                        </select>
                                                    </div>
                                                    <div className="flex gap-4 justify-center">
                                                        {emp.flexi ? (
                                                            <div className="border px-2 py-1">Flexible Time Schedule</div>
                                                        ) : (
                                                            <div className=" flex gap-1 justify-center">
                                                                <input type="time" name="in" onChange={(e)=>handleEditTimeSched(e, emp.user_id, 0)} className="border outline-none cursor-pointer" />
                                                                <div>to</div>
                                                                <input type="time" name="out" onChange={(e)=>handleEditTimeSched(e, emp.user_id, 0)} className="border outline-none cursor-pointer" />
                                                            </div>
                                                        )}
                                                        <div className="flex gap-2 justify-center items-center">
                                                            {emp.btn_loading ? (
                                                                <div>
                                                                    <FontAwesomeIcon className="animate-spin" icon={faSpinner} />
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    <button type="button" onClick={()=>handleUpdateTime(emp.user_id, 0)} className="text-green-500 hover:bg-gray-300 px-2">
                                                                        <FontAwesomeIcon icon={faCheck} />
                                                                    </button>
                                                                    <button type="button" onClick={()=>handleTimeEdit(emp.user_id, 0)} className="text-red-500 hover:bg-gray-300 px-2">
                                                                        <FontAwesomeIcon icon={faTimes} />
                                                                    </button>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </td>
                                        <td className='table-body px-0'>
                                            {!emp.time_sched_editing_onsite ? (
                                                <div className="flex w-full justify-center items-center gap-4">
                                                    <div>
                                                        {emp.current_time_sched_onsite === null || emp.current_time_sched_onsite === '' || emp.current_time_sched_onsite === undefined ? 'Flexible' : convertTime(emp.current_time_sched_onsite)}
                                                    </div>
                                                    <div>
                                                        <button type="button" onClick={()=>handleTimeEdit(emp.user_id, 1)} className="text-blue-500">
                                                            <FontAwesomeIcon icon={faEdit} />
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="flex flex-col gap-2">
                                                    <div>
                                                        <select onChange={()=>handleTimeDropdown(emp.user_id, 1)}>
                                                            <option selected={emp.flexi_onsite} value="">Flexible</option>
                                                            <option selected={!emp.flexi_onsite} value="1">Set Time</option>
                                                        </select>
                                                    </div>
                                                    <div className="flex gap-4 justify-center">
                                                        {emp.flexi_onsite ? (
                                                            <div className="border px-2 py-1">Flexible Time Schedule</div>
                                                        ) : (
                                                            <div className=" flex gap-1 justify-center">
                                                                <input type="time" name="in" onChange={(e)=>handleEditTimeSched(e, emp.user_id, 1)} className="border outline-none cursor-pointer" />
                                                                <div>to</div>
                                                                <input type="time" name="out" onChange={(e)=>handleEditTimeSched(e, emp.user_id, 1)} className="border outline-none cursor-pointer" />
                                                            </div>
                                                        )}
                                                        <div className="flex gap-2 justify-center items-center">
                                                            {emp.btn_loading_onsite ? (
                                                                <div>
                                                                    <FontAwesomeIcon className="animate-spin" icon={faSpinner} />
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    <button type="button" onClick={()=>handleUpdateTime(emp.user_id, 1)} className="text-green-500 hover:bg-gray-300 px-2">
                                                                        <FontAwesomeIcon icon={faCheck} />
                                                                    </button>
                                                                    <button type="button" onClick={()=>handleTimeEdit(emp.user_id, 1)} className="text-red-500 hover:bg-gray-300 px-2">
                                                                        <FontAwesomeIcon icon={faTimes} />
                                                                    </button>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </td>
                                        <td className='table-body px-0'>{employmentStat === 'verified' ? 'Active' : 'Resigned'}</td>
                                        <td className='table-body px-0'>
                                            <button type="button" onClick={()=>createModalContent(<EmployeeData user_id={emp.user_id} />)} className="text-blue-500 hover:underline">
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                )) : Array.from({length : 4}).map((_, index) => (
                                    <tr key={index}>
                                        {[...Array(10)].map((_, colIndex) => (
                                            <td key={colIndex} className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                        ))}
                                    </tr>
                                ))
                                }
                            </tbody>
                        </table>    
                    </div>
                </div>
            </div>
            {showModal &&(
                <Modal onClose={()=>setShowModal(false)}> 
                    {modalChildren}
                </Modal>
            )}
        </div>
    );
}